/**
 * Feature flags for the AI onboarding / import layer.
 * See ONBOARDING-IMPORT-PLAN.md §8 (build order, mock-first).
 *
 *  ONBOARDING_ENABLED  — master switch for every entry point (first-login
 *                        layer, FAB "Import anything", Clients → Import).
 *  ONBOARDING_USE_API  — when false the layer runs against the mock adapter
 *                        that plays the prototype's script on timers, so the
 *                        whole flow can be reviewed before the backend lands.
 *
 * Both are read from the build environment so staging can flip them without
 * a code change: REACT_APP_ONBOARDING=0 turns the feature off,
 * REACT_APP_ONBOARDING_API=1 switches to the real endpoints.
 */
import { SETUP_V2_VISIBLE } from '../../config/featureFlags';

export const ONBOARDING_ENABLED = process.env.REACT_APP_ONBOARDING !== '0';
export const ONBOARDING_USE_API = process.env.REACT_APP_ONBOARDING_API === '1';

/**
 * ONBOARDING_LEAN — the September 2026 cut. The "Needs you" queue keeps only
 * what protects the data (duplicate people, unmapped services, bookings with
 * a gap); the seven salon policy questions and the staff invite deck are
 * out of the first five minutes. Their code stays for a later "finish
 * setting up" deck. The reveal hands over to guided first tasks on the
 * diary, then a single go-live screen.
 */
export const ONBOARDING_LEAN = true;

// File intake limits (plan §10 Q5). Enforced client-side before upload.
export const IMPORT_MAX_FILE_BYTES = 25 * 1024 * 1024;
export const IMPORT_MAX_FILES_PER_JOB = 10;
// Phase 2 (2026-09-17): the backend reads photos and PDFs through the model
// (importExtractor.readWithVision) and refuses appointment exports, so the
// picker offers exactly what the server takes. NOT .heic — the model does not
// accept it, and iOS only transcodes HEIC to JPEG at the picker when the accept
// list leaves it out (2026-08-29 lesson: listing it broke camera uploads).
export const IMPORT_ACCEPT = '.csv,.xlsx,.xls,.pdf,image/jpeg,image/png,image/webp';

/**
 * SETUP_V2_ENABLED: "Set up with Bailey" (the Bailey onboarding plan,
 * 25 Sept 2026). Bailey's welcome hands over to a guided, resumable setup
 * plan instead of the old welcome fork, first-tasks card and Finish setting
 * up list. On for beta and prod since 2026-10-14 (SETUP_V2_VISIBLE).
 */
export const SETUP_V2_ENABLED = ONBOARDING_ENABLED && SETUP_V2_VISIBLE;
